/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Switch, HashRouter } from "react-router-dom";
import BasePage from "./basePage";
import Notification from "./components/Notification";
export default function Routes() {
  return (
    // <OidcProvider configuration={configurationIdentityServer} onEvent={onEvent}>
    <Switch>
      <HashRouter>
        {/* <Notification /> */}
        <BasePage />
      </HashRouter>
    </Switch>
  );
}
